import * as React from 'react'
import { Field } from 'formik'

import { MuiTextFieldFormik } from '@user/components/Formik'

import MenuItem from '@mui/material/MenuItem'

type Props = {
  isUpdate: boolean
}

export function TypeSelect(props: Props) {
  const { isUpdate } = props

  return (
    <Field
      select
      required
      fullWidth
      size="small"
      label="Type"
      margin="normal"
      name="fieldType"
      disabled={isUpdate}
      component={MuiTextFieldFormik}
    >
      <MenuItem value="" disabled>
        Select Type
      </MenuItem>
      <MenuItem value="Text">Text</MenuItem>
      <MenuItem value="Checkbox">Checkbox</MenuItem>
      <MenuItem value="DropdownMultiSelect">Dropdown - Multi Select</MenuItem>
      <MenuItem value="DropdownSingleSelect">Dropdown - Single Select</MenuItem>
      <MenuItem value="Number">Number</MenuItem>
      <MenuItem value="Date">Date</MenuItem>
    </Field>
  )
}
